export interface Response<T> {
  data: T | undefined;
  error: boolean;
  loading: boolean;
}

export const defaultValue: Response<any> = {
  data: undefined,
  error: false,
  loading: false,
};
